import React from "react";

const getClientField = (client, keys) => {
  const sources = [client, client?.data, client?.user, client?.user?.data];

  for (const source of sources) {
    if (!source) continue;

    for (const key of keys) {
      if (source[key]) return source[key];
    }
  }

  return "";
};

const ClientIdentityBadge = ({
  client,
  containerClassName = "theme_container third-party-client-bar",
}) => {
  const firstName = getClientField(client, [
    "firstname",
    "firstName",
    "Firstname",
    "FirstName",
    "first_name",
  ]);
  const lastName = getClientField(client, [
    "lastname",
    "lastName",
    "Lastname",
    "LastName",
    "last_name",
  ]);
  const fullName = `${firstName} ${lastName}`.trim();

  if (!fullName) return null;

  const initials =
    `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase() ||
    fullName
      .split(" ")
      .slice(0, 2)
      .map((name) => name[0])
      .join("")
      .toUpperCase();

  return (
    <div className={containerClassName}>
      <div
        className="third-party-client-badge"
        aria-label={`Logged in as ${fullName}`}
      >
        <span className="third-party-client-avatar">{initials}</span>
        <span className="third-party-client-copy">
          <span className="third-party-client-label">Logged in as</span>
          <strong>{fullName}</strong>
        </span>
      </div>
    </div>
  );
};

export default ClientIdentityBadge;
